import API from "@/assets/core/axios-instance.core";
import { SignInPayload, SignInResponse } from "@/stores/auth/dto";
import { SECRET_KEY } from "@/types/core/secret.type";

const RECAPTCHA_SITE_KEY =
  process.env.VUE_APP_RecaptchaEnterprise_ScoreSiteKey || process.env.VUE_APP_RecaptchaV3_SiteKey || "";
const RECAPTCHA_V2_SITE_KEY =
  process.env.VUE_APP_RecaptchaEnterprise_CheckboxSiteKey || process.env.VUE_APP_RecaptchaV2_SiteKey || "";

class AuthService {
  getLocalAccessToken() {
    const token = localStorage.getItem(SECRET_KEY.ACCESS_TOKEN);
    return token;
  }

  getLocalRefreshToken() {
    const token = localStorage.getItem(SECRET_KEY.REFRESH_TOKEN);
    return token;
  }

  signIn(payload: SignInPayload & { fingerprint?: string }): Promise<SignInResponse> {
    const { recaptchaToken, recaptchaVersion, ...rest } = payload;
    const body: Record<string, unknown> = { ...rest };

    if (recaptchaToken) {
      body.recaptcha_token = recaptchaToken;
    }
    if (recaptchaVersion) {
      body.recaptcha_version = recaptchaVersion;
    }
    const siteKeyToSend =
      recaptchaVersion === "v2" && RECAPTCHA_V2_SITE_KEY
        ? RECAPTCHA_V2_SITE_KEY
        : RECAPTCHA_SITE_KEY;
    if (siteKeyToSend) {
      body.recaptcha_sitekey = siteKeyToSend;
    }

    return API.post("/auth/login", body)
      .then((res) => Promise.resolve(res.data))
      .catch((res) => Promise.reject(res.response.data));
  }
}

export default new AuthService();
